import React, { useState } from 'react';
import _ from 'lodash';
import cn from 'classnames';

import ProgressBar from '../ProgressBar/ProgressBar';
import ImportantNote from './ImportantNote';

import styles from './Steps.module.css';

const Step16 = (props) => {
  const { onSave, stepsData } = props;
  const [drinks, setDrinks] = useState(stepsData.sweet_drinks);
  const [showNote, setShowNote] = useState(false);

  const onFinishSave = () => {
    onSave({ sweet_drinks: drinks });
  };

  const onSaveHandler = () => {
    if (drinks) {
      return setShowNote(true);
    }
    onFinishSave();
  };

  if (showNote) {
    return (
      <ImportantNote
        className={styles.sweetDrinksImportantNote}
        title="Useful note"
        message="Did you know that there are 100-500 kcal in alcoholic drink? Please avoid drinking alcohol or sweet drinks if you want to lose weight."
        onClick={onFinishSave}
      />
    );
  }

  return (
    <div className={styles.stepWrapper}>
      <ProgressBar onSave={onSave} />
      <div className={styles.sweetDrinksContent}>
        <div className={styles.stepHeader}>
          How many alcoholic or fizzy drinks do you have on average per day?
        </div>
        <div className={styles.daysSelect}>
          {_.times(4).map((_, index) => {
            return (
              <div 
                key={index} 
                className={cn(styles.dayButton, { [styles.active]: index == drinks})}
                onClick={() => setDrinks(index)}
              >
                {index}
              </div>
            );
          })}
          <div 
            className={cn(styles.dayButton, { [styles.active]: drinks == 4})}
            onClick={() => setDrinks(4)}
          >
            More than 3
          </div>
        </div>
        <div className={styles.bottomButton}>
          <button
            className="green-button"
            onClick={onSaveHandler}
            disabled={typeof drinks !== 'number'}
          >
            Create Plan
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step16;